import styled from "styled-components";
// @ts-ignore
import buildColor from "@fdr/static-ui/ColorPalette";
// @ts-ignore
import { fontNormal } from "@fdr/static-ui/Typography";

export const StateSelectorWrapper = styled.section<{ isDesktop: boolean }>`
  width: 100%;
  height: 100%;
  padding: 20px 16px;
  background-color: ${buildColor("white", "100")};
  overflow-y: scroll;
  ${({ isDesktop }) =>
    !!isDesktop && `width: 60%; min-width: 768px; margin-left: 20%;`}
`;

export const StateSelectorBackground = styled.div<{ isDesktop: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${buildColor("black", "70")};
  z-index: 99999;
  ${({ isDesktop }) => isDesktop && `padding: 32px;`}
`;

export const Title = styled.h1`
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  line-height: 125%;
  margin-bottom: 4px;
  font-family: ${fontNormal};
  color: ${buildColor("navy", "700")};
`;

export const Description = styled.p`
  font-size: 14px;
  text-align: center;
  line-height: 125%;
  font-family: ${fontNormal};
  color: ${buildColor("grey", "D4")};
`;

export const MenuItemsGroup = styled.ul`
  border: 1px solid ${buildColor("grey", "L2")};
  border-radius: 4px;
  list-style: none;
  overflow: none;
  margin-top: 24px;
`;

export const MenuItem = styled.li`
  display: flex;
  flex-direction: column;
  min-height: 48px;
  box-shadow: inset 0 -1px 0 ${buildColor("grey", "L2")};

  & > a {
    flex: 1;
    padding: 12px 16px;

    & > svg {
      fill: ${buildColor("blue", "D1")};
    }
  }

  &:last-of-type {
    box-shadow: none;
  }
`;
